import { createSlice } from '@reduxjs/toolkit';
import { IQueryParams } from '../../../models/common/IQueryParams';
import { SORT_TYPE } from '../../../constants';
import { defaultServiceListStatus } from '../../../utilities/services/ServiceListUtils';

/**
 * Initial All Event state in store
 */

export interface IServiceFilterState extends IQueryParams {
  sort: string;
  clearData: string;
}

const initialState: IServiceFilterState = {
  searchText: '',
  status: defaultServiceListStatus,
  fromDate: null,
  toDate: null,
  sort: SORT_TYPE.UPDATED_TIMESTAMP_DESC,
  clearData: ''
};

const filterServiceSlice = createSlice({
  name: 'filterService',
  initialState,
  reducers: {
    addFilterServiceData: (state, action) => {
      state.searchText = action.payload.searchText;
      state.status = action.payload.status;
      state.toDate = action.payload.toDate;
      state.fromDate = action.payload.fromDate;
    },
    addSortServiceData: (state, action) => {
      state.sort = action.payload;
    },
    addClearData: (state, action) => {
      state.clearData = action.payload;
    },
    clearFilterService: (state) => {
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
    clearQureyParamService: (state) => {
      state.searchText = '';
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
    removeClearData: (state) => {
      state.clearData = '';
    }
  }
});
export const {
  addFilterServiceData,
  clearFilterService,
  addSortServiceData,
  removeClearData,
  addClearData,
  clearQureyParamService
} = filterServiceSlice.actions;
export default filterServiceSlice.reducer;
